/* eslint-disable no-console */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';

import { Globals } from '../../globals';
import { StorageService } from '../storage/storage.service';
import { LogEntry } from './log.service';

// ****************************************************
// Log Publisher Abstract Class
// NOTE: This class must be located BEFORE
//       all those that extend this class
// ****************************************************
export abstract class LogPublisher {
  location = '';

  abstract log(record: LogEntry): Observable<boolean>;
  abstract clear(): Observable<boolean>;
}

// ****************************************************
// Console Logging Class
// ****************************************************
export class LogConsole extends LogPublisher {
  log(entry: LogEntry): Observable<boolean> {
    // Log to console
    console.info(entry.buildLogString());

    return of(true);
  }

  clear(): Observable<boolean> {
    console.clear();

    return of(true);
  }
}

// ****************************************************
// Local Storage Logging Class
// ****************************************************
export class LogLocalStorage extends LogPublisher {
  constructor() {
    // Must call super() from derived classes
    super();
    // Set location
    this.location = 'logging';
  }

  // Append log entry to local storage
  log(entry: LogEntry): Observable<boolean> {
    let ret = false;
    let values: LogEntry[];

    try {
      // Retrieve previous values from local storage
      const locationLocalStorage = localStorage.getItem(this.location) || null;
      values = locationLocalStorage ? JSON.parse(locationLocalStorage) : [];
      // Add new log entry to array
      values.push(entry);
      // Store array into local storage
      localStorage.setItem(this.location, JSON.stringify(values));

      // Set return value
      ret = true;
    } catch (ex) {
      // Display error in console
      console.error(ex);
    }

    return of(ret);
  }

  // Clear all log entries from local storage
  clear(): Observable<boolean> {
    localStorage.removeItem(this.location);
    return of(true);
  }
}

// ****************************************************
// Logging Web API Class
// ****************************************************
export class LogWebApi extends LogPublisher {
  constructor(
    private readonly http: HttpClient,
    private readonly globals: Globals
  ) {
    // Must call super() from derived classes
    super();
    // Set location
    this.location = '/api/logging';
  }

  // **************
  // Public Methods
  // **************

  // Add log entry to back end data store
  log(entry: any): Observable<boolean> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    const url = this.globals.logRoot + this.location;

    entry.device = '';
    entry.session = '';

    return this.http.post<boolean>(url, entry, { headers: headers }); // .catch(this.handleErrors);
  }

  // Clear all log entries from local storage
  clear(): Observable<boolean> {
    // TODO: Call Web API to clear all values
    return of(true);
  }

  // ***************
  // Private Methods
  // ***************
  private handleErrors(error: any): Observable<any> {
    const errors: string[] = [];
    errors.push(error);
    console.error('An error occurred', errors);
    return throwError(() => errors);
  }
}

// ****************************************************
// Logging SQLITE Class
// ****************************************************
export class LogSqlite extends LogPublisher {
  constructor(private readonly storageService: StorageService) {
    // Must call super() from derived classes
    super();
    // Set location
    this.location = 'logging';

    // this.storageService.createDB();
  }

  log(record: LogEntry): Observable<boolean> {
    let ret = false;

    try {
      // add new row to the database
      this.storageService.insertRow(record.buildLogString());

      // Set return value
      ret = true;
    } catch (ex) {
      // Display error in console
      console.error(ex);
    }

    return of(ret);
  }

  clear(): Observable<boolean> {
    this.storageService.deleteRows();
    return of(true);
  }
}
